var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
import { createReducer } from "@ane/legacy/lib/decorators/ReduxDecorators";
import modalActions from "./BannerActions.js";
const defaultState = { banners: [] };
class BannerReducer {
  addBanner(state, action) {
    if (state.banners.some((b) => b.name === action.payload.name)) {
      return state;
    }
    return __spreadProps(__spreadValues({}, state), {
      banners: [...state.banners, action.payload]
    });
  }
  removeBanner(state, action) {
    return __spreadProps(__spreadValues({}, state), {
      banners: state.banners.filter((b) => b.name !== action.payload)
    });
  }
  removeBannerWithPrefix(state, action) {
    return __spreadProps(__spreadValues({}, state), {
      banners: state.banners.filter((b) => !!b.name && !b.name.startsWith(action.payload))
    });
  }
}
const BannerReducer$1 = createReducer(modalActions, new BannerReducer(), defaultState);
export {
  BannerReducer,
  BannerReducer$1 as default
};
//# sourceMappingURL=BannerReducer.js.map
